var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('h1',{staticClass:"text-center"},[_vm._v("Redirecting to new application.")])])}
var staticRenderFns = []

export { render, staticRenderFns }